import React, { Component } from 'react';
import HeaderTitle from '../../../GeneralComponents/HeaderTitle'
import FormCreate from './FormCreate'
import FormFilter from './FormFilter'
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Preloader from '../../../GeneralComponents/LoadingComponen'

class Index extends Component {
    constructor(props) {
        const date = new Date;
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            modal: false,
            ErrorValues: true,
            showFilter: false,
            modeEdit: false,
            id: "",

            form: {
                name: "",
                total_type: "moneda",
                table_type: "mensual",
                variable_1: "",
                variable_2: "",
                actual_year: "",
                initial_variables: "",
                indicator_type: this.props.type,

                analyzed_position_id: "",
                reviewed_position_id: "",
                approved_position_id: "",
                sub_category_indicator_id: this.props.sub_category_indicator != null ? this.props.sub_category_indicator.id : "",
                category_indicator_id: this.props.category_indicator.id,
                description: "",
            },

            formFilter: {
                years: [],
            },

            selectedOptionSubCategory: {
                sub_category_indicator_id: "",
                label: "Sub categoría"
            },

            selectedOptionPosition1: {
                analyzed_position_id: "",
                label: "Integra"
            },

            selectedOptionPosition2: {
                reviewed_position_id: "",
                label: "Analiza"
            },

            selectedOptionPosition3: {
                approved_position_id: "",
                label: "Aprueba"
            },

            selectedOptionMulti: {
                years: [],
                label: "Seleccione el año"
            },

            position: [],
            years: [
                { label: "2020", value: "2020" },
                { label: "2021", value: "2021" },
                { label: "2022", value: "2022" },
                { label: "2023", value: "2023" },
                { label: "2024", value: "2024" },
                { label: "2025", value: "2025" }

            ]
        }
    }


    //selects 

    handleChangeAutocomplete1 = selectedOptionPosition1 => {
        this.setState({
            selectedOptionPosition1,
            form: {
                ...this.state.form,
                analyzed_position_id: selectedOptionPosition1.value
            }
        });

    };

    handleChangeAutocomplete2 = selectedOptionPosition2 => {
        this.setState({
            selectedOptionPosition2,
            form: {
                ...this.state.form,
                reviewed_position_id: selectedOptionPosition2.value
            }
        });

    };


    handleChangeAutocompleteMulti = selectedOptionMulti => {
        let array = []

        selectedOptionMulti.map((item) => (
            array.push(item.value)
        ))

        this.setState({
            formFilter: {
                ...this.state.formFilter,
                years: array
            }
        })
    }

    handleChangeAutocomplete3 = selectedOptionPosition3 => {
        this.setState({
            selectedOptionPosition3,
            form: {
                ...this.state.form,
                approved_position_id: selectedOptionPosition3.value
            }
        });

    };

    componentDidMount = () => {
        this.positionSelect();
    }

    positionSelect = () => {
        let array = [];

        this.props.cargos.map((item) => (
            array.push({ label: item.name, value: item.id })
        ))

        this.setState({
            position: array
        })
    }

    validationForm = () => {
        if (this.state.form.name != "" &&
            this.state.form.actual_year != "" &&
            this.state.form.initial_variables != (this.props.type == "SEGV" ? "" : "*") &&

            this.state.form.variable_1 != (this.props.type != "SEGV" ? "" : "*") &&
            this.state.form.variable_2 != (this.props.type != "SEGV" ? "" : "*") &&


            this.state.form.analyzed_position_id != "" &&
            this.state.form.reviewed_position_id != "" &&
            this.state.form.approved_position_id != ""
        ) {
            this.setState({ ErrorValues: true })
            return true
        } else {
            this.setState({ ErrorValues: false })
            return false

        }
    }

    //   this.state.modeEdit == false ? this.state.form.password != "" : "",
    //   this.state.modeEdit == false ? this.state.form.password_confirmation != "" : "",

    messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    clearValues = () => {
        this.setState({
            form: {
                name: "",
                variable_1: "",
                variable_2: "",
                actual_year: "",
                total_type: "moneda",
                table_type: "mensual",
                initial_variables: "",
                indicator_type: this.props.type,

                analyzed_position_id: "",
                reviewed_position_id: "",
                approved_position_id: "",
                sub_category_indicator_id: this.props.sub_category_indicator != null ? this.props.sub_category_indicator.id : "",
                category_indicator_id: this.props.category_indicator.id,
                description: "",
            },

            selectedOptionSubCategory: {
                sub_category_indicator_id: "",
                label: "Sub categoría"
            },

            selectedOptionPosition1: {
                analyzed_position_id: "",
                label: ""
            },

            selectedOptionPosition2: {
                reviewed_position_id: "",
                label: ""
            },

            selectedOptionPosition3: {
                approved_position_id: "",
                label: ""
            },


            modeEdit: false,
            ErrorValues: true,
            id: "",
        })
    }

    edit = (indicator) => {
        this.setState({
            form: {
                ...this.state.form,
                name: indicator.name,
                total_type: indicator.total_type,
                variable_1: indicator.variable_1,
                variable_2: indicator.variable_2,
                table_type: indicator.table_type,
                actual_year: indicator.actual_year,

                analyzed_position_id: indicator.analyzed_position != null ? indicator.analyzed_position.id : "",
                approved_position_id: indicator.approved_position != null ? indicator.approved_position.id : "",
                reviewed_position_id: indicator.reviewed_position != null ? indicator.reviewed_position.id : "",
                description: indicator.description,
            },

            selectedOptionPosition1: {
                analyzed_position_id: indicator.analyzed_position != null ? indicator.analyzed_position.id : "",
                label: `${indicator.analyzed_position != null ? indicator.analyzed_position.name : ""}`
            },

            selectedOptionPosition2: {
                reviewed_position_id: indicator.approved_position != null ? indicator.approved_position.id : "",
                label: `${indicator.approved_position != null ? indicator.approved_position.name : ""}`
            },

            selectedOptionPosition3: {
                approved_position_id: indicator.reviewed_position != null ? indicator.reviewed_position.id : "",
                label: `${indicator.reviewed_position != null ? indicator.reviewed_position.name : ""}`
            },

            id: indicator.id,
            modal: true,
            modeEdit: true,
        })
    }

    toogle = (from) => {
        if (from == "new") {
            this.setState({ modal: true })
            this.clearValues();
        } else {
            this.setState({ modal: false })
        }
    }

    getNameTitle = (name) => {
        const indicadores = "Indicadores"
        if (name == "SACLI") {
            return `${this.props.category_indicator.name}: ${indicadores} ${this.props.user.app_type == "Mejora" ? "Financieros" : "Clinicos"}`
        } else if (name == "SAADM") {
            return `${this.props.category_indicator.name}: ${indicadores}  ${this.props.user.app_type == "Mejora" ? "Clientes" : "Administrativos"}`
        } else if (name == "SAOP") {
            return `${this.props.category_indicator.name}: ${indicadores} ${this.props.user.app_type == "Mejora" ? "Procesos" : "Operativos"}`
        } else if (name == "SAMEJ") {
            return `${this.props.category_indicator.name}: ${indicadores} ${this.props.user.app_type == "Mejora" ? "Personal" : "Mejora"}`
        } else if (name == "SEGV") {
            return `${this.props.category_indicator.name}: ${indicadores} de Segmentación de ventas`
        } else if (name == "PDT") {
            return `${this.props.category_indicator.name}: ${indicadores} de Seguridad del Paciente`
        }

    }


    HandleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    }

    HandleClick = () => {
        if (this.validationForm() == true) {
            this.props.updateStateLoad(false)
            if (this.state.modeEdit == false)
                fetch(`/indicator/category_indicators/${this.props.category_indicator.id}/indicators`, {
                    method: 'POST', // or 'PUT'
                    body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => res.json())
                    .catch(error => console.error("Error:", error))
                    .then(data => {
                        this.props.loadData();
                        this.clearValues();
                        this.setState({ modal: false })
                        this.props.updateStateLoad(true)
                        this.messageSuccess(data);
                    });
            else {
                fetch(`/indicator/category_indicators/${this.props.category_indicator.id}/indicators/${this.state.id}`, {
                    method: 'PATCH', // or 'PUT'
                    body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => res.json())
                    .catch(error => console.error("Error:", error))
                    .then(data => {
                        this.props.loadData();
                        this.clearValues();
                        this.setState({ modal: false })
                        this.props.updateStateLoad(true)
                        this.messageSuccess(data);
                    });
            }
        }
    }

    delete = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si"
        }).then(result => {
            if (result.value) {
                fetch(`/indicator/category_indicators/${this.props.category_indicator.id}/indicators/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.props.loadData()
                        this.messageSuccess(response)
                    });
            }
        });
    };


    getMonthText = (fecha) => {
        let months = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'];
        return months[fecha]
    }

    showIndicator = (value) => {
        let month = new Date().getMonth();

        month = value.table_type == "mensual" ? (month - 1) : month

        if (value.indicator_data_tables != undefined) {
            month = month < 0 ? 0 : month
            let accumulated = value.indicator_data_tables[2].data_indicators[month].percentege;

            let cumplimiento = ["% cumplimiento", "0%", this.getMonthText(month)];
            if (accumulated != 0) {
                cumplimiento = ["% cumplimiento", `${accumulated}%`, this.getMonthText(month)];

            }
            return cumplimiento

        }

    }
    numberToCurrency = (amount) => {

        amount = amount ? amount : 0
        var thousandsSeparator = ","
        var currencyNum = "";
        var amountString = amount.toString();
        var digits = amountString.split("");

        var countDigits = digits.length;
        var revDigits = digits.reverse();

        for (var i = 0; i < countDigits; i++) {
            if ((i % 3 == 0) && (i != 0)) {
                currencyNum += thousandsSeparator + revDigits[i];
            } else {
                currencyNum += digits[i];
            }
        };

        var revCurrency = currencyNum.split("").reverse().join("");

        var finalCurrency = "$" + revCurrency;

        return finalCurrency;
    }

    openIndicator = (value) => {
        window.location.href = `/indicator/category_indicators/${this.props.category_indicator.id}/indicators/${value}`;
    }

    toogleFilter = (state) => {
        if (!state) {
            this.props.loadData()
        }

        this.setState({
            showFilter: (state == undefined ? true : state)
        })
    }

    handleClickFilter = () => {
        this.props.updateStateLoad(false)
        fetch(`${this.props.url}?years=${this.state.formFilter.years}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                this.props.setData(data.data)
            });
    }

    handleChangeAutocompleteSubCategory = selectedOptionSubCategory => {
        this.setState({
            selectedOptionSubCategory,
            form: {
                ...this.state.form,
                sub_category_indicator_id: selectedOptionSubCategory.value
            }
        });
    };

    render() {
        return (
            <React.Fragment>
                <HeaderTitle
                    title={this.props.category_indicator_view ? `${this.props.category_indicator.name}` : `${this.props.sub_category_indicator.name}`}
                    subTitle={this.props.category_indicator_view ? `Gestión de Indicadores` : `Gestión de Indicadores de ${this.props.category_indicator.name}`}
                    titleNew={"Nuevo indicador"}
                    titleFilter={"Filtros"}
                    onClickNew={this.toogle}
                    showNew={this.props.estados.crear}
                    onClickFilter={() => this.toogleFilter()}
                    showFilter={true}
                />

                {this.state.showFilter && (
                    <FormFilter
                        showFilter={this.state.showFilter}
                        handleClickFilter={this.handleClickFilter}
                        toogleFilter={this.toogleFilter}
                        years={this.state.years}
                        selectedOptionMulti={this.state.selectedOptionMulti}
                        handleChangeAutocompleteMulti={this.handleChangeAutocompleteMulti}
                    />
                )}

                {this.state.modal && (
                    <FormCreate
                        //modal props
                        backdrop={"static"}
                        modal={this.state.modal}
                        toggle={this.toogle}
                        title={this.state.modeEdit ? "Editar Indicador" : "Agregar nuevo Indicador"}
                        modeEdit={this.state.modeEdit}

                        //form props
                        formValues={this.state.form}
                        errorValues={this.state.ErrorValues}
                        onChangeForm={this.HandleChange}
                        submitForm={this.HandleClick}
                        nameSubmit={this.state.modeEdit ? "Actualizar" : "Crear"}
                        isLoaded={this.props.isLoaded}

                        //type
                        type={this.props.type}

                        //select1

                        selectedOptionPosition1={this.state.selectedOptionPosition1}
                        handleChangeAutocomplete1={this.handleChangeAutocomplete1}

                        //select2

                        selectedOptionPosition2={this.state.selectedOptionPosition2}
                        handleChangeAutocomplete2={this.handleChangeAutocomplete2}

                        //select3

                        selectedOptionPosition3={this.state.selectedOptionPosition3}
                        handleChangeAutocomplete3={this.handleChangeAutocomplete3}

                        //select sub category
                        selectedOptionSubCategory={this.state.selectedOptionSubCategory}
                        handleChangeAutocompleteSubCategory={this.handleChangeAutocompleteSubCategory}
                        sub_category_indicators_select={this.props.sub_category_indicators_select}


                        position={this.state.position}
                    />
                )}

                {this.props.isLoaded ? (
                    <React.Fragment>
                        <div className="row">
                            {this.props.category_indicator_view ? (
                                <React.Fragment>
                                    <div className="col-md-12 mb-3">
                                        <div className="row">
                                            {this.props.sub_category_indicators.map((sub_category_indicator, index) => (
                                                <div className={`col-md-3 mt-4 ${index == 0 ? "" : ""}`} key={sub_category_indicator.id}>
                                                    <div className="card p-3 display-flex jc-space-between card-indicator-subcategory">
                                                        <a
                                                            href={`/indicator/sub_category_indicators/${sub_category_indicator.id}`}
                                                            data-turbolinks="false"
                                                            className="label-20" title={sub_category_indicator.name}
                                                        >
                                                            {sub_category_indicator.name}
                                                        </a>
                                                        <i class="metismenu-icon fas fa-chart-line label-30"></i>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {this.props.sub_category_indicators.length > 0 && this.props.data.length >= 1 && (
                                        <div className="col-md-12 mb-3">
                                            <hr />
                                        </div>
                                    )}
                                </React.Fragment>

                            ) : (

                                <div className="col-md-12">
                                    <nav aria-label="breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a href={`/indicator/category_indicators/${this.props.category_indicator.id}/indicators?type=SACLI&name=${this.props.category_indicator.name}`} data-turbolinks="false">{this.props.category_indicator.name}</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">{this.props.sub_category_indicator.name}</li>
                                        </ol>
                                    </nav>
                                </div>

                            )}
                        </div>

                        {this.props.data.length >= 1 ? (
                            <div className="row indicators-wp">
                                {this.props.data.map(indicator => (
                                    <div className="col-md-4 mb-4">
                                        <div className="card">
                                            <div className="card-body card-ventas-gerencia">
                                                <p className="card-ventas-name">{indicator.name}</p>
                                                <p class="card-ventas-name" style={{ fontSize: 16 }}>({indicator.actual_year})</p>
                                                <hr />
                                                <p className="card-ventas-value"> {this.showIndicator(indicator) != undefined ? this.showIndicator(indicator)[1] : ""} </p>
                                                <p className="card-ventas-desc">{this.showIndicator(indicator) != undefined ? this.showIndicator(indicator)[0] : ""} <br /><span>{this.showIndicator(indicator) != undefined ? this.showIndicator(indicator)[2] : ""}</span></p>
                                            </div>

                                            <div className="card-footer">

                                                {this.props.estados.editar && (
                                                    <a
                                                        className="btn"
                                                        onClick={() => this.edit(indicator)}
                                                    >
                                                        <i className="fas fa-pen"></i>
                                                    </a>
                                                )}

                                                {this.props.estados.eliminar && (
                                                    <a
                                                        className="btn"
                                                        onClick={() => this.delete(indicator.id)}
                                                    >
                                                        <i className="fas fa-trash-alt"></i>
                                                    </a>
                                                )}

                                                {this.props.estados.gestionar && (
                                                    <div className="text-right" style={{ width: "100%" }}>
                                                        <button className="btn btn-primary" onClick={() => this.openIndicator(indicator.id)}> Ver Indicador</button>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        ) : (
                            <React.Fragment>
                                {this.props.sub_category_indicators.length <= 0 && (
                                    <div className="card">
                                        <div className="card-body text-center">
                                            <h4>No hay indicadores</h4>
                                        </div>
                                    </div>
                                )
                                }

                            </React.Fragment>
                        )}
                    </React.Fragment>
                ) : (
                    <div className="col-md-12 text-center">
                        <Preloader />
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default Index;